// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1iV0T","content":"GlobalSearch_content__3D1Q6"};